
import React, { Fragment, useEffect, useState } from "react";
import 'react-toastify/dist/ReactToastify.css';
import { Link, useNavigate , useLocation } from "react-router-dom";
import Spinner from "../FieldComponets/Spinner";
import { useDispatch, useSelector } from 'react-redux';
import ToastDefault from "../FieldComponets/Toast";
import PageLayout from "../Layouts/PageLayout";
import { getDate, getItemFromStorage, setItemToStorage, userPicUrl } from "../../utils/Helper";
import { decodeID  , getLastURL } from "../../utils/Helper";
import { ContactDetailsGetAction } from "../../Redux/Action/ContactAction";
import { FormattedMessage, useIntl } from "react-intl";



function Contactdetails() {
    const dispatch = useDispatch<any>();
    const navigate = useNavigate()
    const intl = useIntl();
    const log_in = useSelector((state: any) => state.AdminLogInState)
    const contact_us_details = useSelector((state: any) => state.ContactDetailsState?.data?.data?.detail)
    const location = useLocation();
    const editId = getLastURL(location);
     const [loading  , setLoading] = useState(false)


    const handleBack = () => {
        navigate('/contact-us')
    }
    useEffect(()=>{
        setLoading(true)
        var params = {
            detail_id: decodeID(editId)
        };
     dispatch(ContactDetailsGetAction(params))
     setTimeout(() => {
        setLoading(false)
     }, 400);
    },[])
    return (
        <Fragment>
            { loading || log_in?.loading ? <Spinner /> : ""}
            <PageLayout
                title={<FormattedMessage id="user_support_management" />}
                breadcrumbs={{
                    secLast: { 'link': '/contact-us', 'name': <FormattedMessage id="user_support_management" /> },
                }}
                buttons={[
                    { url: '/class-add', className: 'btn btn-primary', text: '+ Add Sponsors', show: false }, // This button will be shown
                ]}
            >


                <div className="card">
                    <div className="card-body">
                        <div className="row gy-4">
                            <div className="col-md-6">
                                <div className="row">
                                    <div className="col-md-3">
                                        <label htmlFor="username" className="form-label"><FormattedMessage id="customer_id" />:</label>
                                    </div>
                                    <div className="col-md-9">
                                        <span>{contact_us_details?.id ? contact_us_details?.id : '--'}</span>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="row">
                                    <div className="col-md-3">
                                        <label htmlFor="username" className="form-label"><FormattedMessage id="name" /></label>
                                    </div>
                                    <div className="col-md-9">
                                        <span>{contact_us_details?.name ? contact_us_details?.name : '--'}</span>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="row">
                                    <div className="col-md-3">
                                        <label htmlFor="username" className="form-label"><FormattedMessage id="mobile" /></label>
                                    </div>
                                    <div className="col-md-9">
                                        <span>{contact_us_details ? `${contact_us_details?.phone_country_code || '--'}  ${contact_us_details.phone_number || '--'}` : '--'}</span>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="row">
                                    <div className="col-md-3">
                                        <label htmlFor="username" className="form-label"><FormattedMessage id="description" /></label>
                                    </div>
                                    <div className="col-md-9">
                                        <span>{contact_us_details?.description ? contact_us_details?.description : '--'}</span>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="row">
                                    <div className="col-md-3">
                                        <label htmlFor="username" className="form-label"><FormattedMessage id="email" /></label>
                                    </div>
                                    <div className="col-md-9">
                                        <span>{contact_us_details?.email ? contact_us_details?.email : '--'}</span>
                                    </div>
                                </div>
                            </div>
                           
                            <div className="col-md-6">
                                <div className="row">
                                    <div className="col-md-3">
                                        <label htmlFor="username" className="form-label"><FormattedMessage id="status" /></label>
                                    </div>
                                    <div className="col-md-9">
                                        <span>{contact_us_details?.is_reply == "1" ? intl.formatMessage({ id: "replied" }) : intl.formatMessage({ id: "not_replied" })}</span>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="row">
                                    <div className="col-md-3">
                                        <label htmlFor="username" className="form-label"><FormattedMessage id="date" /></label>
                                    </div>
                                    <div className="col-md-9">
                                        <span>{contact_us_details?.created_at ? getDate(contact_us_details?.created_at) : '--'}</span>
                                    </div>
                                </div>
                            </div>
                            <div className="col-12">
                                <button type="submit" className="btn btn-primary waves-effect waves-light" onClick={() => handleBack()} ><FormattedMessage id="back" /></button>
                            </div>
                        </div>
                    </div>
                </div>
                <ToastDefault />
            </PageLayout>
        </Fragment>
    );
}

export default Contactdetails;




